import { render, staticRenderFns } from "./AddWorkcenter.vue?vue&type=template&id=f158bea6&"
import script from "./AddWorkcenter.vue?vue&type=script&lang=js&"
export * from "./AddWorkcenter.vue?vue&type=script&lang=js&"
import style0 from "./AddWorkcenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports